import { Form } from '@anytag/shared-atoms';
import { formatProposedInfluencersData } from '../utils';
import { ProposeInfluencersFormValues } from '../schemaTypes';
import { useUserProposalContext } from '../UserProposalContext';
import { useProposedInfluencersSearch, useSaveProposal } from '../hooks';
import { Template, TemplateProps } from './Template';

type SelectedInfluencersProps = Omit<TemplateProps, 'data'>;

export const SelectedInfluencers = (props: SelectedInfluencersProps) => {
  const { jdMode } = props.tableModeProps;

  const { selectedInfluencers } = useUserProposalContext();
  const { isEditMode } = useProposedInfluencersSearch();
  const { handleSaveProposal } = useSaveProposal({ jdMode });
  const { tableData, formValues } = formatProposedInfluencersData(selectedInfluencers, jdMode, isEditMode);

  return (
    <Form.Provider<ProposeInfluencersFormValues>
      values={formValues}
      onSubmit={handleSaveProposal(tableData)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault(); // Prevent form submit on Enter key, user needs to click the Save button
        }
      }}
    >
      <Template {...props} data={tableData} />
    </Form.Provider>
  );
};
